import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";

class Orders extends PureComponent {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path
                    d="M23.4,6L12.3,2.1c-0.2-0.1-0.4-0.1-0.7,0l-2.8,1C8.3,3.3,8.2,3.5,8.7,3.8L19,7.5c0.3,0.1,0.5,0.4,0.5,0.8V9
    c0,0.4-0.3,0.8-0.6,0.9l-1.1,0.4c-0.6,0.2-1.3,0.1-1.3-0.6V9.4c0-0.4-0.2-0.8-0.6-0.9L5.5,4.6C5.3,4.5,5,4.5,4.8,4.6L0.6,6
    C0.3,6.2,0,6.5,0,6.9l0,9.8c0,0.4,0.2,0.8,0.6,0.9l10.9,4.3c0.2,0.1,0.5,0.1,0.7,0l11.2-4.3c0.4-0.1,0.6-0.5,0.6-0.9V6.9
    C24,6.5,23.7,6.1,23.4,6z M20.4,15.9L17.3,17c-0.6,0.3-1.2-0.3-1.2-1l0-2.1c0-0.4,0.2-0.8,0.6-0.9l3.1-1.2c0.6-0.2,1.3,0.2,1.3,0.9
    l0,2.2C21,15.4,20.8,15.7,20.4,15.9z"
                />
            </SvgIcon>
        );
    }
}

export default Orders;
